export const DEFAULT_CONFIG = {
  boxId: null,
  page: 0,
  urlParameter: 'page',
  loadingText: 'Načítám...',
  quantity: 10,
  transform: null,
  insertPlace: 'before',
  paginationLimit: 30,
  magazineName: 'Název magazínu',
};

export interface LoadMoreConfig {
  boxId?: string;
  page?: number;
  nextRequestUrl?: string;
  urlParameter?: string;
  loadingText?: string;
  quantity?: number;
  transform?: object;
  insertPlace?: string;
  paginationLimit?: number;
  magazineName?: string;
}

export const EVENT_BEFORE_LOAD = 'load-more--before-load';
export const EVENT_AFTER_LOAD = 'load-more--after-load';
export const EVENT_AFTER_INSERT = 'load-more--after-insert';
export const EVENT_ERROR = 'load-more--error';
